import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

export default function LinkInBio() {
  const [products, setProducts] = useState([]);
  const [wa, setWa] = useState("");

  useEffect(() => {
    document.title = "NALURA — Semua Link";
    axios.get(`${API}/products`).then((r) => setProducts(r.data)).catch(() => {});
    axios.get(`${API}/contact`).then((r) => setWa(r.data.wa_number || "")).catch(() => {});
  }, []);

  return (
    <div className="bg-[#FBF7EE] text-[#211B10] min-h-screen py-12 px-5" data-testid="bio-page">
      <div className="max-w-md mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="text-center mb-10">
          <img src="/nalura-logo.jpg" alt="Logo NALURA" className="w-24 h-24 object-contain mix-blend-multiply mx-auto mb-3" />
          <h1 className="font-display text-4xl tracking-tight">NALURA<span className="text-[#A67C1E]">.</span></h1>
          <p className="font-mono text-[9px] uppercase tracking-[0.3em] text-[#A67C1E] mt-2">Good Mind Good Life</p>
          <p className="text-sm text-[#211B10]/60 mt-4 leading-relaxed">
            Kurasi program pengembangan diri terbaik — ubah pola pikir, raih ketenangan & kelimpahan.
          </p>
        </motion.div>

        <div className="space-y-3">
          {products.map((p, i) => (
            <motion.div key={p.product_id} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.1 + i * 0.07 }}>
              <Link
                to={`/p/${p.slug || p.product_id}`}
                data-testid={`bio-link-${p.product_id}`}
                className={`group flex items-center gap-4 border p-4 transition-colors duration-300 ${
                  p.coming_soon
                    ? "border-[#A67C1E]/50 bg-[#A67C1E]/5 hover:bg-[#A67C1E]/10"
                    : "border-[#211B10]/12 bg-white hover:border-[#A67C1E]/60"
                }`}
              >
                <img src={p.image_url} alt={p.name} className="w-14 h-14 object-cover border border-[#211B10]/10 shrink-0" />
                <span className="flex-1 min-w-0">
                  <span className="block text-sm font-medium leading-snug">{p.name}</span>
                  <span className="block font-mono text-[9px] uppercase tracking-[0.15em] text-[#A67C1E] mt-1 truncate">
                    {p.coming_soon ? "✦ Open Pre-Order" : p.tagline}
                  </span>
                </span>
                <ArrowRight className="w-4 h-4 text-[#211B10]/30 group-hover:text-[#A67C1E] group-hover:translate-x-1 transition-all duration-300 shrink-0" />
              </Link>
            </motion.div>
          ))}
        </div>

        {wa && (
          <a
            data-testid="bio-wa-button"
            href={`https://wa.me/${wa}?text=${encodeURIComponent("Halo NALURA! Saya mau tanya tentang produknya.")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 flex items-center justify-center gap-2 bg-[#25D366] text-white text-xs font-medium uppercase tracking-[0.15em] px-6 py-4 hover:opacity-90 transition-opacity"
          >
            <WhatsAppIcon className="w-4 h-4" /> Tanya via WhatsApp
          </a>
        )}

        <Link to="/" data-testid="bio-home-link" className="mt-8 flex items-center justify-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-[#211B10]/50 hover:text-[#A67C1E] transition-colors">
          <Sparkles className="w-3.5 h-3.5" /> Kunjungi Website Lengkap
        </Link>
      </div>
    </div>
  );
}
